// itg js
var locationHref = location.href,
  checkUrl = locationHref.includes('?contact_posted=true'),
  getUrl = location.pathname;
if(checkUrl){
  $('.contact-popup-wrapper').show();
}
$(document).on('click','.check-item',function () {
    var email = $('input#ContactForm-email').val().trim(),
      phone = $('input#ContactForm-tel').val().trim();

    let result = email.includes("@");
    var mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if(email == '' || result == false || email.match(mailformat) == null){
      $('input#ContactForm-email').parents('.form-input-main').addClass('error-main');
    }else{
      $('input#ContactForm-email').parents('.form-input-main').removeClass('error-main');
    }

    var phoneno = /^\d{10}$/;
    if(phone == '' || phone.match(phoneno) == null){
      $('input#ContactForm-tel').parents('.form-input-main').addClass('error-main');
    }else{
      $('input#ContactForm-tel').parents('.form-input-main').removeClass('error-main');
    }
  

  if($(document).find('.ctm-hiiden-input').length > 1){}else{
  $(document).find('.bcpo-simple input[type="radio"]:checked').each(function(){
    var inputVal = $(this).val(),
      inputName = $(this).attr('name').replace('properties','contact');
      $('.contact-popup-form-content form#ContactForm').append(`<input class="ctm-hiiden-input" type="hidden" name="`+inputName+`" value="`+inputVal+`">`);
  });

  if($('.bcpo-simple input[type="checkbox"]:checked').length){
  var checkVal = [];
    $(document).find('.bcpo-simple input[type="checkbox"]:checked').each(function(){
      var inputTextVal = $(this).val(),
        inputTextName = $(this).attr('name');
      if(inputTextVal != '' && inputTextVal != null){
          checkVal.push(inputTextVal);
      }
    }).promise().done( function(){
      var inputTextName = $('.bcpo-simple input[type="checkbox"]:checked').attr('name').replace('properties','contact').replace('[]','');
      $('.contact-popup-form-content form#ContactForm').append(`<input class="ctm-hiiden-input" type="hidden" name="`+inputTextName+`" value="`+checkVal+`">`);
    });
  }  
    
  $(document).find('.bcpo-simple select').each(function(){
    var selectVal = $(this).val(),
      selectName = $(this).attr('name').replace('properties','contact');
    if(selectVal != '' && selectVal != null){
      // console.log(selectVal);
      $('.contact-popup-form-content form#ContactForm').append(`<input class="ctm-hiiden-input" type="hidden" name="`+selectName+`" value="`+selectVal+`">`);
    }
  })
  
  $(document).find('.bcpo-simple textarea').each(function(){
    var textVal = $(this).val(),
        textName = $(this).attr('name').replace('properties','contact'),
        result = false;
      if($(this).parents('.bcpo-simple').find('div[style]').length){
        var style = $(this).parents('div').attr('style'),
        result = style.includes("none");
      }
    // console.log($(this).parents('.bcpo-simple').find('div[style]').length);
     if(textVal != ''){
      if(result){}else{
         $('.contact-popup-form-content form#ContactForm').append(`<input class="ctm-hiiden-input" type="hidden" name="`+textName+`" value="`+textVal+`">`);
       }  
    }
  });

  $(document).find('.bcpo-simple input[type="text"]').each(function(){
    var inputTextVal = $(this).val(),
      inputTextName = $(this).attr('name').replace('properties','contact');
    if(inputTextVal != '' && inputTextVal != null){
      // console.log(inputTextVal);
      $('.contact-popup-form-content form#ContactForm').append(`<input class="ctm-hiiden-input" type="hidden" name="`+inputTextName+`" value="`+inputTextVal+`">`);
    }
  })
    
}


  if(email.match(mailformat) && phone.match(phoneno)){
    setTimeout(function(){
      $('.form-submit-main button').trigger('click');
    });
  }
});
$(document).on('click','span#close-form',function () {
  $('.contact-popup-wrapper').hide();
  $(document).find('.ctm-hiiden-input').remove();
  var locationHref = location.href,
  checkUrl = locationHref.includes('?contact_posted=true'),
  getUrl = location.pathname;
  if(checkUrl){
    $(".contact-popup-wrapper").load(getUrl+" .contact-popup-wrapper>*","");
    window.history.pushState({"html":'',"pageTitle":''},"", getUrl);
  }
});
$('button#contact-me-btn').click(function () {
  var locationHref = location.href,
  checkUrl = locationHref.includes('?contact_posted=true'),
  getUrl = location.pathname;
  if(checkUrl){
    $(".contact-popup-wrapper").load(getUrl+" .contact-popup-wrapper>*","");
    window.history.pushState({"html":'',"pageTitle":''},"", getUrl);
  }
  $(document).find('.ctm-hiiden-input').remove();
  var priceVal = $('[data-sezzleindex]').text();
  $('.contact-popup-form-content form#ContactForm').append(`<input class="ctm-hiiden-input" type="hidden" name="contact[product-price]" value="`+priceVal+`">`)
  $('.contact-popup-wrapper').show();
})